<template>
  <div v-if="!dismissed" class="h-full text-white pl-ogs-large pr-12">
    <div
      class="flex flex-col h-full items-center justify-center text-xs md:text-sm font-bold"
      id="tickerContainer"
    >
      <div v-show="hasTicker" class="w-full">
        <marquee-text :repeat="10" :duration="20">
          <span class="px-5">{{ message }}</span>
        </marquee-text>
      </div>
      <div v-show="!hasTicker" id="tickerMessage" class="whitespace-no-wrap">{{ message }}</div>
    </div>
    <div class="absolute inset-y-0 right-0 flex items-center">
      <button
        class="link w-10 h-10 flex items-center justify-center"
        @click="dismissed = true"
      >
        <div class="w-3 h-3">
          <IconCrossSmall />
        </div>
        <span class="sr-only">Dismiss message</span>
      </button>
    </div>
  </div>
</template>

<script>
import IconCrossSmall from "../../templates/_includes/svg/icon-cross-small.svg";
import MarqueeText from 'vue-marquee-text-component';

export default {
  name: "SiteMessage",

  components: { 
    IconCrossSmall,
    MarqueeText
  },

  props: {
    message: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      dismissed: window.sessionStorage.getItem("siteMessageDismissed") || false,
      hasTicker: false,
    };
  },

  computed: {
    messageHeight() {
      return this.dismissed
        ? "0rem"
        : `${this.$root.siteMessageHeight / 16}rem`;
    },
  },

  watch: {
    dismissed(value) {
      window.sessionStorage.setItem("siteMessageDismissed", value);
      this.setMessageHeight();
    },
  },

  beforeMount() {
    this.setMessageHeight();
    if (!this.message) this.dismissed = true;
  },

  methods: {
    // setting the message height is important because we are using the css custom property to calculate heights in other areas of the site
    setMessageHeight() {
      document.documentElement.style.setProperty(
        "--site-message-height",
        this.messageHeight
      );
    },
  },

  mounted() {
    this.hasTicker = document.getElementById('tickerContainer').offsetWidth < document.getElementById('tickerMessage').offsetWidth; 
  }
};
</script>